import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    fontFamily: "MontserratBold",
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  },
  chipList: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
  },
  chip: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    border: "1.5px solid #00DD9E",
    color: "#00DD9E",
    fontFamily: "Montserrat",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "1.4",
    backgroundColor: "transparent",
    cursor: "default",
    transition: "background-color 0.2s ease, color 0.2s ease",
    "&:hover": {
      backgroundColor: "#00DD9E",
      color: "#fff",
    },
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
  },
}));

export default useStyles;
